<template>
  <div
    class="img-box"
    :style="{
      width: `${typeof width === 'number' ? `${width}px` : width}`,
      height: `${typeof height === 'number' ? `${height}px` : height}`,
      backgroundColor: bgColor,
      backgroundImage: `url(${imgSrc})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50%',
      backgroundSize: 'contain',
      borderRadius: `${borderRadius}px`
    }"
  ></div>
</template>
<script>
export default {
  name: 'ImgBox',
  props: {
    borderRadius: {
      type: Number,
      default: 0
    },
    width: {
      type: [Number, String],
      default: '100%'
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    bgColor: {
      type: String,
      default: 'transparent'
    },
    src: {
      type: String,
      default: ''
    }
  },
  computed: {
    imgSrc () {
      return typeof this.width === 'number' && typeof this.height === 'number'
        ? `${this.src}?imageView&thumbnail=${this.height}x${this.height}`
        : typeof this.width === 'number'
          ? `${this.src}?imageView&thumbnail=${this.width}x0`
          : typeof this.height === 'number'
          ? `${this.src}?imageView&thumbnail=0x${this.height}`
          : `${this.src}?imageView&thumbnail=0x62`
    }
  }
}
</script>
